import { useEffect, useState } from "react";
import moment from "moment";
import Styles from "./style.module.css";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import {
    AddFbar,
    GET_FBAR_details_data,
    GET_FBAR_update,
} from "Services/Requests";
import Load from "Components/Loader/loader";
import { showSuccessNotification } from "Utils/Notifications";
import { showWarningAlert } from "Utils/Alerts";
import { useSearchParams } from "react-router-dom";
import { useStore } from "Store";
interface Inputs {
    acc_belongs_to: "string";
    bank_name: string;
    bank_address: string;
    city: string;
    pincode: string;
    state: string;
    acc_no: string;
    type_of_account: string;
    street_address: string;
    account_maintenance_currency: number;
    any_income_earned_in_XX: number;
    income_earned_details: string;
    maximum_value_in_acc: number;
    value_of_account: number;
    joint_owner_name: string;
}

function Fbar() {
    const { isDisabled } = useStore((state: any) => state);
    const [isChecked, setIschecked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchparams] = useSearchParams();
    const {
        register,
        handleSubmit,
        watch,
        setValue,

        control,
        reset,
        formState: { errors },
    } = useForm<Inputs>({ defaultValues: { any_income_earned_in_XX: 0 } });

    const formData = watch();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const GetDetails = async (id: any) => {
        setLoading(true);
        try {
            const response = await GET_FBAR_details_data(id);
            setTimeout(() => {
                setLoading(false);
            }, 300);
            if (response.data.status == 1) {
                reset(response.data.fbar_details);
            } else {
                showWarningAlert(
                    "Something went wrong try again,if Issue persists Contact Support team"
                );
                setLoading(false);
            }
        } catch (err: any) {
            showWarningAlert(
                "Something went wrong try again,if Issue persists Contact Support team"
            );
            setLoading(false);
        }
    };
    useEffect(() => {
        if (searchparams.get("id")) GetDetails(searchparams.get("id"));
    }, []);
    const onsubmit: SubmitHandler<Inputs> = async (data) => {
        if (!isChecked) {
            return;
        }
        let body = [
            {
                Table: "fbar",
                Data: {
                    acc_belongs_to: data.acc_belongs_to,
                    bank_name: data.bank_name,
                    bank_address: data.bank_address,
                    city: data.city,
                    state: data.state,
                    maximum_value_in_acc: data.maximum_value_in_acc,
                    acc_no: data.acc_no,
                    type_of_account: data.type_of_account,
                    pincode: data.pincode,
                    street_address: data.street_address,
                    account_maintenance_currency:
                        data.account_maintenance_currency,
                    joint_owner_name: data.joint_owner_name,
                    any_income_earned_in_XX: data.any_income_earned_in_XX,
                    income_earned_details: data.income_earned_details,
                    value_of_account: data.value_of_account,
                },
            },
        ];
        setLoading(true);
        if (searchparams.get("id")) {
            try {
                const response = await GET_FBAR_update(
                    searchparams.get("id"),
                    body
                );
                setLoading(false);
                if (response.data.Status === 1) {
                    showSuccessNotification("FBAR updated successfully");
                } else {
                    showWarningAlert(
                        response?.data.Message ||
                            "Somethign went wrong try again"
                    );
                }
            } catch (err: any) {
                showWarningAlert(
                    "Something went wrong try again,if Issue persists Contact Support team"
                );
                setLoading(false);
            }
        } else {
            try {
                const response = await AddFbar({
                    ...body[0].Data,
                    tax_file_year_id: localStorage.getItem("Year_id"),
                });
                setLoading(false);
                if (response.data.Status === 1) {
                    showSuccessNotification("FBAR Added successfully");
                } else {
                    showWarningAlert(
                        response?.data.Message ||
                            "Somethign went wrong try again"
                    );
                }
            } catch (err: any) {
                showWarningAlert(
                    "Something went wrong try again,if Issue persists Contact Support team"
                );
                setLoading(false);
            }
        }
    };
    return (
        <div className={Styles["Container"]}>
            {loading && <Load />}

            <form action="" onSubmit={handleSubmit(onsubmit)}>
                <div className={Styles["info"]}>
                    <h3>
                        Foreign Bank Account Reporting (FBAR) –{" "}
                        {moment().subtract(0, "year").format("YYYY")}
                        <br />
                        <span
                            style={{
                                fontWeight: "500",
                                fontSize: "0.9rem",
                                color: "#5A6D81",
                            }}>
                            A United States person, including a citizen,
                            resident, corporation, partnership, limited
                            liability company, trust and estate, must file FBAR
                            <br />
                            If the person transferred or maintained the
                            aggregate value of those foreign financial accounts
                            exceeded $10,000 at any time during the calendar
                            year need to file
                        </span>
                    </h3>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">Ownership</label>
                        <input
                            disabled={isDisabled}
                            type="text"
                            placeholder="Write Ownership Name"
                            className={
                                errors?.acc_belongs_to && Styles["error-input"]
                            }
                            {...register("acc_belongs_to", {
                                required: false,
                                pattern: {
                                    value: /^[A-Za-z\s]*$/, // Allows alphabetic characters and spaces
                                    message:
                                        "Only alphabetic characters and spaces are allowed",
                                },
                            })}
                        />
                        {errors?.acc_belongs_to && (
                            <p>{errors?.acc_belongs_to?.message} </p>
                        )}
                    </div>{" "}
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">Account Number</label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            placeholder=" account No"
                            className={errors?.acc_no && Styles["error-input"]}
                            {...register("acc_no", {
                                required: false,
                            })}
                        />
                        {errors?.acc_no && <p>{errors?.acc_no?.message} </p>}
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">
                            Name of Bank or Financial Institution
                        </label>
                        <input
                            disabled={isDisabled}
                            type="text"
                            placeholder="Name of the bank"
                            className={
                                errors?.bank_name && Styles["error-input"]
                            }
                            {...register("bank_name", {
                                required: false,
                                pattern: {
                                    value: /^[A-Za-z\s]*$/, // Allows alphabetic characters and spaces
                                    message:
                                        "Only alphabetic characters and spaces are allowed",
                                },
                            })}
                        />
                        {errors?.bank_name && (
                            <p>{errors?.bank_name?.message} </p>
                        )}
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">Bank Address</label>
                        <input
                            disabled={isDisabled}
                            type="text"
                            placeholder="Enter Address"
                            className={
                                errors?.bank_address && Styles["error-input"]
                            }
                            {...register("bank_address", {
                                required: false,
                            })}
                        />
                        {errors?.bank_address && <p>This is required </p>}
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">Street Address</label>
                        <input
                            disabled={isDisabled}
                            type="text"
                            placeholder="Enter Address"
                            className={
                                errors?.street_address && Styles["error-input"]
                            }
                            {...register("street_address", {
                                required: false,
                            })}
                        />
                        {errors?.street_address && <p>This is required </p>}
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">City</label>
                        <input
                            disabled={isDisabled}
                            type="text"
                            placeholder="Enter City"
                            className={errors?.city && Styles["error-input"]}
                            {...register("city", {
                                required: false,
                            })}
                        />
                        {errors?.city && <p>This is required </p>}
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">State</label>
                        <input
                            disabled={isDisabled}
                            type="text"
                            placeholder="Enter State"
                            className={errors?.state && Styles["error-input"]}
                            {...register("state", {
                                required: false,
                            })}
                        />
                        {errors?.state && <p>This is required </p>}
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">Postal Address</label>
                        <input
                            disabled={isDisabled}
                            type="text"
                            placeholder="Enter Postal Code"
                            className={errors?.pincode && Styles["error-input"]}
                            {...register("pincode", {
                                required: false,
                            })}
                        />
                        {errors?.pincode && <p>This is required </p>}
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">Type of account</label>
                        <input
                            disabled={isDisabled}
                            type="text"
                            placeholder="Ex-savings"
                            className={
                                errors?.type_of_account && Styles["error-input"]
                            }
                            {...register("type_of_account", {
                                required: false,
                            })}
                        />
                        {errors?.type_of_account && <p>This is required </p>}
                    </div>
                    {/* <div className={Styles["form-control"]}>
                        <label htmlFor="">If others please specify</label>
                        <input disabled={isDisabled} type="text" placeholder="Enter Description" />
                    </div> */}
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">
                            Foreign currency in which acct is maintained
                        </label>
                        <Controller
                            name="account_maintenance_currency"
                            control={control}
                            disabled={isDisabled}
                            rules={{
                                required: "This is required",
                            }}
                            render={({ field }) => (
                                <input
                                    {...field}
                                    className={
                                        errors?.account_maintenance_currency &&
                                        Styles["error-input"]
                                    }
                                    type="text" // Use type="text" to better control the value
                                    placeholder="Ex-INR"
                                    onInput={(e) => {
                                        // Cast the event target to HTMLInputElement to access value
                                        const input =
                                            e.target as HTMLInputElement;
                                        input.value = input.value.replace(
                                            /[^A-Za-z]/g, // Replace non-alphabetic characters
                                            ""
                                        );
                                    }}
                                />
                            )}
                        />
                        {/*  <input
                            disabled={isDisabled}
                            type="text"
                            placeholder="Ex-INR"
                            className={
                                errors?.account_maintenance_currency &&
                                Styles["error-input"]
                            }
                            {...register("account_maintenance_currency", {
                                required: false,
                            })}
                        /> */}
                        {errors?.account_maintenance_currency && (
                            <p>This is required </p>
                        )}
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">
                            Name of Joint Owner (if not spouse)
                        </label>
                        <input
                            disabled={isDisabled}
                            type="text"
                            placeholder="Enter Name"
                            className={
                                errors?.joint_owner_name &&
                                Styles["error-input"]
                            }
                            {...register("joint_owner_name", {
                                required: false,
                                pattern: {
                                    value: /^[A-Za-z\s]*$/, // Allows alphabetic characters and spaces
                                    message:
                                        "Only alphabetic characters and spaces are allowed",
                                },
                            })}
                        />
                        {errors?.joint_owner_name && (
                            <p>{errors?.joint_owner_name?.message} </p>
                        )}
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">
                            Account value as on 31-Dec-
                            {moment().subtract(0, "year").format("YYYY")}
                        </label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            placeholder="Enter Value"
                            className={
                                errors?.value_of_account &&
                                Styles["error-input"]
                            }
                            {...register("value_of_account", {
                                required: false,
                            })}
                        />
                        {errors?.value_of_account && <p>This is required </p>}
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">
                            Maximum Value of Account during{" "}
                            {moment().subtract(0, "year").format("YYYY")} in
                            Foreign currency
                        </label>
                        <input
                            disabled={isDisabled}
                            type="number"
                            placeholder="Enter Amount"
                            className={
                                errors?.maximum_value_in_acc &&
                                Styles["error-input"]
                            }
                            {...register("maximum_value_in_acc", {
                                required: false,
                            })}
                        />
                        {errors?.maximum_value_in_acc && (
                            <p>This is required </p>
                        )}
                    </div>
                    <div
                        className={Styles["form-control"]}
                        style={{
                            gridColumn: "1/-1",
                            display: "flex",
                            gap: "0.5rem",
                            alignItems: "center",
                        }}>
                        <input
                            disabled={isDisabled}
                            type="checkbox"
                            id="income"
                            checked={formData.any_income_earned_in_XX == 1}
                            onChange={(e) =>
                                setValue(
                                    "any_income_earned_in_XX",
                                    e.target.checked ? 1 : 0
                                )
                            }
                        />

                        <label htmlFor="income">
                            Income earned in the account during{" "}
                            {moment().subtract(0, "year").format("YYYY")}
                        </label>
                    </div>
                    {formData.any_income_earned_in_XX === 1 && (
                        <div
                            className={Styles["form-control"]}
                            style={{ gridColumn: "1/-1" }}>
                            <textarea
                                rows={6}
                                placeholder={`Please provide`}
                                {...register("income_earned_details", {
                                    required:
                                        formData.any_income_earned_in_XX == 1,
                                })}
                            />
                            {errors?.income_earned_details && (
                                <p>This is required</p>
                            )}
                        </div>
                    )}
                    <div
                        className={Styles["declaration"]}
                        style={{ gridColumn: "1/-1" }}>
                        <h3>
                            <input
                                disabled={isDisabled}
                                type="checkbox"
                                id="pushNotification"
                                onChange={(e) => setIschecked(e.target.checked)}
                            />
                            <label
                                htmlFor="pushNotification"
                                className={Styles["checkbox-label"]}>
                                I declare that the information in this
                                application is true and correct{" "}
                            </label>
                        </h3>
                        <div className={Styles["save-btns"]}>
                            <button disabled={isDisabled || !isChecked}>
                                Save
                            </button>
                            {/*   <button type="button">Reset</button> */}
                        </div>
                    </div>
                </div>
            </form>
            {/* <button >Submit</button> */}
        </div>
    );
}

export default Fbar;
